<template>
  <base-page :title="$t('l.system_setting')" icon="md-settings">
    <template slot="extra">
      <Button type="primary" :loading="loading" @click="onSave">{{ !loading ? $t('l.save') : 'loading...' }}</Button>
      <Button class="margin-left-10" @click="loadData(1)">{{ $t('l.fresh') }}</Button>
    </template>
    <template>
      <Row :gutter="16">
        <Col span="6">
          <Card class="bright-card" :title="$t('l.system_select')" icon="ios-options" :padding="0" shadow>
            <CellGroup v-for="(item,index) in cell" @on-click="clickCell" :key="index">
              <Cell :name="item.name" v-if="$ifauth(item.isRoot)" :title="item.title"
                    :selected="item.selected" :label="item.label"/>
            </CellGroup>
          </Card>
        </Col>
        <Col span="18">
          <Card class="setting-content" dis-hover v-show="settingContent.actived==0">
            <h3 slot="title">
              {{ $t('l.basic_set') }}
            </h3>
            <Row style="display: flex">
              <Col>
                <div class="face-data-img-box">
                  <img :src="head_url"/>
                </div>
              </Col>
              <Col span="14">
                <Form ref="user" :model="user" :rules="formRules" :label-width="105">
                  <Row>
                    <Col span="16">
                      <FormItem :label="$t('l.username')" prop="username">
                        <Input :disabled="true" v-model="user.username"
                               :placeholder="$t('l.username_account')"></Input>
                      </FormItem>
                      <FormItem :label="$t('l.name')" prop="realname">
                        <Input v-model="user.realname" :placeholder="$t('l.real_name')"></Input>
                      </FormItem>
                      <FormItem :label="$t('l.mobile')" prop="mobile">
                        <Input :disabled="true" v-model="user.mobile"
                               :placeholder="$t('l.mobile')"></Input>
                      </FormItem>
                      <FormItem :label="$t('l.job_num')">
                        <Input v-model="user.job_num" :placeholder="$t('l.job_num')"></Input>
                      </FormItem>
                      <FormItem :label="$t('l.position')" prop="job">
                        <Input v-model="user.job" :placeholder="$t('l.position')"></Input>
                      </FormItem>
                      <FormItem :label="$t('l.e_mail')" prop="email">
                        <Input v-model="user.email" type="email"
                               :placeholder="$t('l.e_mail')"></Input>
                      </FormItem>
                      <!--<FormItem :label="$t('l.birthday')" prop="birthday">-->
                      <!--<DatePicker v-model="user.birthday" type="date" :placeholder="$t('l.birthday')"></DatePicker>-->
                      <!--</FormItem>-->
                      <FormItem :label="$t('l.current_department')">
                        <Input v-model="current_company" disabled
                               :placeholder="$t('l.current_department')"></Input>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==1">
            <h3 slot="title">
              {{ $t('l.data_monitor_set') }}
            </h3>
            <Row>
              <!-- 电梯监控 设备的默认到期时间 -->
              <Row v-if="settings && settings.j_monitor_config" class="margin-bottom-10">
                <div class="flex-align-center">
                  <span>{{$t('l.lift_monitor_config')}}：</span>
                  <InputNumber :max="24" :formatter="value => `${value}个月`"
                               :parser="value => value.replace('个月', '')" :min="1"
                               v-model="settings.j_monitor_config.config.end_time"/>
                </div>
                <p class="explain">{{$t('l.warn_note')}}：{{ $t('l.explain8') }}</p>
              </Row>
            </Row>
            <Row :gutter="10" class="full" v-if="settings && settings.j_monitor_config">
              <Col span="8">
                <Card :title="$t('l.list_page')" class="bright-card">
                  <Form :label-width="100">
                    <FormItem :label="$t('l.report_interval')">
                      <InputNumber :min="1" v-model="settings.j_monitor_config.config.page_list.interval"/>
                    </FormItem>
                    <FormItem :label="$t('l.duration')">
                      <InputNumber :min="1" v-model="settings.j_monitor_config.config.page_list.keep"/>
                    </FormItem>
                    <!--<FormItem :label-width="95" :label="$t('l.report_interval')">-->
                    <!--<Slider  show-input-->
                    <!--v-model="settings.j_monitor_config.config.page_list.interval"></Slider>-->
                    <!--</FormItem>-->
                    <!--<FormItem :label-width="95" :label="$t('l.duration')">-->
                    <!--<Slider :min="settings.j_monitor_config.config.page_list.interval"-->
                    <!--:max="600" show-input-->
                    <!--v-model="settings.j_monitor_config.config.page_list.keep"></Slider>-->
                    <!--</FormItem>-->
                  </Form>
                </Card>
              </Col>
              <Col span="8">
                <Card :title="$t('l.detail_page')" class="bright-card">
                  <Form :label-width="100">

                    <FormItem :label="$t('l.report_interval')">
                      <InputNumber :min="1" v-model="settings.j_monitor_config.config.page_detail.interval"/>
                    </FormItem>
                    <FormItem :label="$t('l.duration')">
                      <InputNumber :min="1" v-model="settings.j_monitor_config.config.page_detail.keep"/>
                    </FormItem>
                    <!--<FormItem :label-width="95" :label="$t('l.report_interval')">-->
                    <!--<Slider :step="0.1" show-input-->
                    <!--v-model="settings.j_monitor_config.config.page_detail.interval"></Slider>-->
                    <!--</FormItem>-->
                    <!--<FormItem :label-width="95" :label="$t('l.duration')">-->
                    <!--<Slider :min="10" :max="600" show-input-->
                    <!--v-model="settings.j_monitor_config.config.page_detail.keep"></Slider>-->
                    <!--</FormItem>-->
                  </Form>
                </Card>
              </Col>
              <Col span="8" style="height: 100%">
                <Card :title="$t('l.para_monitor')" class="full bright-card">
                  <CheckboxGroup v-model="settings.j_monitor_config.fields" class="checkBox">
                    <Checkbox class="check-box-line" v-for="(item, key) in paramMap" :label="key"
                              :key="key">{{ item }}
                    </Checkbox>
                  </CheckboxGroup>
                </Card>
              </Col>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==2">
            <h3 slot="title">
              {{ $t('l.webRTC_set') }}
            </h3>
            <Row style="height: 400px;" type="flex">
              <Col span="10">
                <Card class="bright-card" :title="$t('l.webRTC_related_set')">
                  <Form v-if="settings.webrtc">
                    <FormItem>
                      <Input :value="settings.webrtc.car" @input="webrtc.data.car = $event;">
                        <span slot="prepend">{{ $t("l.smart_screen") }}：</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="settings.webrtc.app" @input="webrtc.data.app = $event;">
                        <span slot="prepend">{{ $t("l.dty") }} APP：</span>
                      </Input>
                    </FormItem>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==3">
            <h3 slot="title">
              {{ $t('l.app_v_manage') }}
            </h3>
            <Row>
              <Card class="bright-card" :title="$t('l.app_v_manage')" type="flex">
                <Row style="margin-bottom: 10px">
                  <p class="explain">{{ $t('l.remark28') }}</p>
                </Row>
                <Row>
                  <Form>
                    <FormItem>
                      <Input value="http://static.diantiyun.com/upload/apk/diantiyun.apk"
                             :disabled="true">
                        <span slot="prepend">url:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="app_version.android.size"
                             @input="app_version.android.size = $event;">
                        <span slot="prepend">size:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="app_version.android.versions"
                             @input="app_version.android.versions = $event;">
                        <span slot="prepend">version:</span>
                      </Input>
                    </FormItem>
                  </Form>
                  <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :on-success="handleSuccess"
                      :data="{index:0}"
                      :format="['apk']"
                      :on-format-error="handleFormatError"
                      :multiple="false"
                      :action="uploadAddress">
                    <Button>{{ $t('l.upload_apk') }}</Button>
                  </Upload>
                  <div style="width: 400px;margin-top: 24px">
                    <Carousel v-if="settingContent.actived==3" v-model="carousel.value">
                      <CarouselItem v-for="(item,index) in carousel.index_banner" :key="index">
                        <div style="width: 100%;height: 100%">
                          <div style="height: 165px">
                            <img :src="item.url" :alt="$t('l.remark29')">
                          </div>
                          <div style="display: flex;justify-content: center;align-items: center">
                            <Upload :show-upload-list="false" :action="uploadAddress"
                                    :data="{index:index}"
                                    :on-success="uploadSuccess">
                              <div style="position: relative;bottom: 90px;">
                                <Button class="opacity" icon="ios-cloud-upload-outline">
                                  {{ $t("l.upload_img") }}
                                </Button>
                              </div>
                            </Upload>
                          </div>
                        </div>
                      </CarouselItem>
                    </Carousel>
                  </div>
                </Row>
              </Card>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==4">
            <h3 slot="title">
              {{ $t('l.face_v_manage') }}
            </h3>
            <Row :gutter="8">
              <Col span="14">
                <Card class="bright-card" :title="$t('l.face_v_manage')">
                  <Row style="margin: 20px 0">
                    <p class="explain">{{ $t('l.remark30') }}</p>
                  </Row>
                  <Form>
                    <FormItem>
                      <Input :value="face.name" @input="face.name = $event;">
                        <span slot="prepend">name:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="face.url" @input="face.url = $event;">
                        <span slot="prepend">url:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="face.file_size" @input="face.file_size = $event;">
                        <span slot="prepend">size:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="face.version" @input="face.version = $event;">
                        <span slot="prepend">version:</span>
                      </Input>
                    </FormItem>
                  </Form>
                  <Row>
                    <Upload
                        ref="upload"
                        :show-upload-list="true"
                        :on-success="handleSuccess"
                        :data="{index:1}"
                        :format="['apk']"
                        :on-format-error="handleFormatError"
                        :multiple="false"
                        :action="uploadAddress"
                        style="display: inline-block;width:58px;">
                      <Button>{{ $t('l.upload_apk') }}</Button>
                    </Upload>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==5">
            <h3 slot="title">
              {{ $t('l.smart_v_manage') }}
            </h3>
            <Row :gutter="8">
              <Col span="14">
                <Card class="bright-card" :title="$t('l.smart_v_manage')">
                  <Row style="margin: 20px 0">
                    <p class="explain">{{ $t('l.remark30') }}</p>
                  </Row>
                  <Form>
                    <FormItem>
                      <Input :value="terminal.name" @input="terminal.name = $event;">
                        <span slot="prepend">name:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="terminal.url" @input="terminal.url = $event;">
                        <span slot="prepend">url:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="terminal.file_size" @input="terminal.file_size = $event;">
                        <span slot="prepend">size:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="terminal.version" @input="terminal.version = $event;">
                        <span slot="prepend">version:</span>
                      </Input>
                    </FormItem>
                  </Form>
                  <Row>
                    <Upload
                        ref="upload"
                        :show-upload-list="true"
                        :on-success="handleSuccess"
                        :data="{index:2}"
                        :format="['apk']"
                        :on-format-error="handleFormatError"
                        :multiple="false"
                        :action="uploadAddress"
                        style="display: inline-block;width:58px;">
                      <Button>{{ $t('l.upload_apk') }}</Button>
                    </Upload>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Card>

          <Card class="setting-content" dis-hover v-show="settingContent.actived==12">
            <h3 slot="title">
              {{ $t('l.smartlite_v_manage') }}
            </h3>
            <Row :gutter="8">
              <Col span="14">
                <Card class="bright-card" :title="$t('l.smartlite_v_manage')">
                  <Row style="margin: 20px 0">
                    <p class="explain">{{ $t('l.remark30') }}</p>
                  </Row>
                  <Form>
                    <FormItem>
                      <Input :value="terminallite.name" @input="terminallite.name = $event;">
                        <span slot="prepend">name:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="terminallite.url" @input="terminallite.url = $event;">
                        <span slot="prepend">url:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="terminallite.file_size" @input="terminallite.file_size = $event;">
                        <span slot="prepend">size:</span>
                      </Input>
                    </FormItem>
                    <FormItem>
                      <Input :value="terminallite.version" @input="terminallite.version = $event;">
                        <span slot="prepend">version:</span>
                      </Input>
                    </FormItem>
                  </Form>
                  <Row>
                    <Upload
                        ref="upload"
                        :show-upload-list="true"
                        :on-success="handleSuccess"
                        :data="{index:4}"
                        :format="['apk']"
                        :on-format-error="handleFormatError"
                        :multiple="false"
                        :action="uploadAddress"
                        style="display: inline-block;width:58px;">
                      <Button>{{ $t('l.upload_apk') }}</Button>
                    </Upload>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==6">
            <p slot="title">
              {{ $t('l.fault_set') }}
            </p>
            <Row>
              <div style="margin-bottom: 20px;display: flex;align-items: center">
                <Checkbox v-model="allCheak1" @on-change="changeCheck($event,1)"><span
                    class="ivu-cell-title">{{ $t('l.all_fault_alarm') }}</span></Checkbox>
                <Checkbox v-model="allCheak2" @on-change="changeCheck($event,2)"><span
                    class="ivu-cell-title">{{ $t('l.all_sms_alarm') }}</span></Checkbox>
                <div style="display: flex;">
                  <div class="ivu-cell-title">{{ $t('l.hint17') }}</div>
                  <div class="margin-left-10">
                    <i-switch v-model="closeFaultNotice" @on-change="closeFnotice"/>
                  </div>
                </div>
              </div>
            </Row>
            <Row style="max-height: 60vh;overflow-y: auto">
              <template v-if="settingContent.actived==6">
                <Table :max-height="500" :loading="faultNotice.loading" :row-class-name="rowClassName"
                       :data="faultNotice.faults" :columns="faultNotice.columns" :border="true">
                  <template slot-scope="{ row }" slot="alarm">
                    <Checkbox :value="faultNotice.list.j_alarm_config.includes(row.fault_no)"
                              @on-change="onFaultAlarmConfigChange($event, row.fault_no)"></Checkbox>
                  </template>
                  <template slot-scope="{ row }" slot="sms">
                    <Checkbox :value="faultNotice.list.j_sms_config.includes(row.fault_no)"
                              @on-change="onFaultSmsConfigChange($event, row.fault_no)"></Checkbox>
                  </template>
                </Table>
              </template>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==7">
            <h3 slot="title">{{ $t('l.aliyun_interface_set') }}</h3>
            <Row>
              <template v-if="settings.aliyun_config">
                <Row>
                  <Button icon="md-add" type="primary" @click="preAddNewTaocan">{{ $t('l.add') }}
                  </Button>
                </Row>
                <Row :gutter="10" class="margin-top-10">
                  <Col span="12" v-for="(taocan,index_t) in settings.aliyun_config.simPackages"
                       :key="taocan.offerid">
                    <Card class="bright-card" :title="$t('l.package') + `${index_t+1}`">
                      <Form :label-width="80">
                        <FormItem :label="$t('l.package_name')">
                          <Input v-model="taocan.name" :placeholder="$t('l.package_name')"/>
                        </FormItem>
                        <FormItem :label="$t('l.package_type')">
                          <RadioGroup v-model="taocan.type">
                            <Radio label="A">
                              <span>{{ $t('l.month_sub') }}</span>
                            </Radio>
                            <Radio label="B">
                              <span>{{ $t('l.superposition') }}</span>
                            </Radio>
                          </RadioGroup>
                        </FormItem>
                        <FormItem :label="$t('l.flow_data')">
                          <Input v-model="taocan.flow"></Input>
                        </FormItem>
                        <FormItem :label="$t('l.original_price')">
                          <InputNumber v-model="taocan.originPrice" :min="0"></InputNumber>
                          {{ $t('l.unit2') }}
                        </FormItem>
                        <FormItem :label="$t('l.discount_price')">
                          <InputNumber v-model="taocan.price" :min="0"></InputNumber>
                          {{ $t('l.unit2') }}
                        </FormItem>
                        <FormItem :label="$t('l.package_id')">
                          <Input v-model="taocan.offerid"></Input>
                        </FormItem>
                      </Form>
                    </Card>
                  </Col>
                </Row>
              </template>
            </Row>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==8">
            <h3 slot="title">{{ $t('l.newWcr_v_manage') }}</h3>
            <Card class="bright-card" :title="$t('l.newWcr_v_manage')">
              <Row>
                <Col span="6">
                  <h4>{{ $t('l.list_v') }}</h4>
                  <ul class="margin-top-10">
                    <li class="margin-bottom-10" v-for="(item,index) in wcr.wcrFileList"
                        :key="index">{{ index + 1 }}、{{ item }}
                    </li>
                  </ul>
                </Col>
                <Col span="8">
                  <Upload
                      ref="upload"
                      :before-upload="handleBeforeUpload"
                      :show-upload-list="true"
                      :on-success="handleSuccess"
                      :data="{index:3}"
                      :multiple="false"
                      :action="uploadAddress">
                    <Button>{{ $t('l.upload') }}</Button>
                  </Upload>
                </Col>
              </Row>
            </Card>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==9">
            <h3 slot="title">{{ $t('l.api_set1') }}</h3>
            <Row>
              <!--<Card class="bright-card" :title="$t('l.api_set2')">-->
              <Button class="margin-right-10" type="primary" @click="add_settings">{{ $t('l.add') }}</Button>

<!--              <Button class="margin-right-10" type="primary" @click="synchro_redis(1)">{{ $t("l.sync_all") }}</Button>-->

<!--              <Button class="margin-right-10" type="primary" @click="synchro_redis(2)">-->
<!--                {{ $t("l.synchronization_part") }}（仅同步redis中不存在的）-->
<!--              </Button>-->

<!--              2025年7月30日  同步全部设备的账号信息  同步后不再使用-->
<!--              <Button class="margin-right-10" type="primary" @click="updateShemeCodeToDevice">{{ $t("l.sync_all") }}</Button>-->


              <h4 class="margin-top-10 margin-bottom-10">{{ $t('l.set_list') }}</h4>
              <Col span="6" v-for="(item,index) in modal.list" :key="index">
                <Card>
                  <h4 solt="title">
                    <Icon type="md-pin" size="22"/>
                    <span class="text-font-size">{{ item.name }}</span>
                  </h4>
                  <Row slot="extra" type="flex" justify="end">
                    <a class="pre-edit" href="#" @click.prevent="preEdit(index)">
                      {{ $t('l.edit') }}
                    </a>
                  </Row>
                  <Divider class="margin-bottom-10 margin-top-10"/>
                  <div style="max-height: 60px;height: 60px;overflow-y: auto">
                    <p v-for="(elem,i) in item.j_factory" :key="i">
                      {{
                        elem ==
                        '*' ? $t('l.all_factory') : factoryMap[elem] ? factoryMap[elem].name : ''
                      }}
                    </p>
                  </div>
                </Card>
              </Col>
              <!--</Card>-->
            </Row>
            <Spin v-if="settingContent.loading9 && modal.list.length" fix class="full"></Spin>
          </Card>
          <Card class="setting-content" dis-hover v-show="settingContent.actived==10">
            <p slot="title">
              {{ $t('l.parts_life_settings') }}
            </p>
            <Row>
              <div style="margin-bottom: 20px;display: flex;align-items: center">
                <Checkbox v-model="allCheak3" @on-change="onChangeAllPartsLife">全选</Checkbox>
              </div>
            </Row>
            <Row style="max-height: 60vh;overflow-y: auto">
              <template v-if="settingContent.actived==10">
                <Table :max-height="500" :row-class-name="rowPartsClassName"
                       :data="partsLifeNotice.data" :columns="columns" :border="true">
                  <template slot-scope="{ row }" slot="alarm">
                    <Checkbox :value="!!partsLifeNotice.list.config.find(elem => elem.id==row.id)"
                              @on-change="onPartsLifeNoticeChange($event, row)"></Checkbox>
                  </template>
                </Table>
              </template>
            </Row>
          </Card>

          <Card class="setting-content" dis-hover v-show="settingContent.actived==11">
            <p slot="title">
              {{ $t('l.sys_nettrans_server') }}
            </p>
            <Row style="max-height: 60vh;overflow-y: auto">
              <Col span="10">
                <Card class="bright-card" :title="$t('l.sys_nettrans_server')">
                  <Form v-if="settings.net_trans">
                    <FormItem>
                      <Input :value="settings.net_trans" @input="net_trans = $event">
                        <span slot="prepend">URL：</span>
                      </Input>
                    </FormItem>
                  </Form>
                </Card>
              </Col>

            </Row>
          </Card>
        </Col>
      </Row>
    </template>
    <template>
      <lg-modal :width="900" :show="modal.show" :title="modal.title" @on-cancel="modal.show=false"
                @on-submit="onSubmit('modal','modal.t_push')" :confirm-text="$t('l.save')">
        <Form ref="modal" :model="modal" style="max-height: 660px;overflow-y: auto">
          <!-- 推送平台标签 -->
          <FormItem :label="$t('l.region_select')" prop="t_push.label"
                    :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}">
            <Input v-model="modal.t_push.label"/>
          </FormItem>
          <!-- 推送平台名称 -->
          <FormItem :label="$t('l.push_name')" prop="t_push.name"
                    :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}">
            <Input v-model="modal.t_push.name"/>
          </FormItem>
          <FormItem :label="$t('l.push_port')">
            <InputNumber v-model="modal.t_push.port" :min="0" :max="9999999" :step="1"/>
          </FormItem>
<!--          <FormItem :label="$t('l.manufacturer') ">-->
<!--            <Select :placeholder="$t('l.select_manufacturer2')"-->
<!--                    @on-change="selectFactory"-->
<!--                    ref="selectFactory"-->
<!--                    v-model="modal.t_push.j_factory"-->
<!--                    filterable-->
<!--                    multiple-->
<!--                    clearable-->
<!--                    remote-->
<!--                    :remote-method="remoteSearchFactory"-->
<!--                    :loading="searchLoading">-->
<!--              <Option value="*">全部厂商</Option>-->
<!--              <Option v-for="(factory) in modal.factory.factorys" :value="factory.id"-->
<!--                      :key="factory.id">{{ factory.name }}-->
<!--              </Option>-->
<!--            </Select>-->
<!--          </FormItem>-->
          <!--                  是否开启事件存储-->
          <FormItem :label="$t('l.event_save')">
            <i-switch v-model="modal.t_push.is_evet_save" true-value="1" false-value="0"/>
          </FormItem>

          <!--                  说明文档上传-->
          <FormItem :label="$t('l.doc_upload')">
            <Upload
                multiple
                accept="pdf"
                :show-upload-list="true"
                :on-success="handleDocUploadSuccess"
                :on-remove="removeDocUpload"
                :on-format-error="handleDocUploadError"
                :format="['pdf']"
                :headers={Authorization:$store.state.user.user.token}
                :action="uploadPDFAddress">
              <Button icon="ios-cloud-upload-outline">点击上传文件（多选）</Button>
            </Upload>
          </FormItem>
<!--          2025年8月8日  王欢  按照 柳 要求 新增一个禁用字段 选中禁用 用户在电梯列表中的推送平台配置中 该平台不可见-->
          <FormItem style="display: flex;align-items: center" :label="$t('l.sms_enable_0')" >
            <i-switch v-model="modal.t_push.disabled" :true-value="1" size="small" :false-value="0"/>
          </FormItem>
          <FormItem :label="$t('l.push_setting') + ' :'" v-if="modal.t_push.j_config.length"></FormItem>
          <Row v-if="modal.t_push.j_config.length">
            <Form ref="modal.t_push"
                  :model="modal.t_push"
                  class="push-way-form"
                  v-for="(item,index) in modal.t_push.j_config" :key="index">
              <Row style="display: flex;flex-direction: column">
                <FormItem :label="$t('l.add_filed')+(index+1)+':'"
                          :prop="'j_config.'+index+'.filed'"
                          :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}">
                  <Input style="width: 300px" class="setting-filed-input" v-model="item.filed"
                         :placeholder="$t('l.remark34')"/>
                </FormItem>
                <!--<div class="filed-explain-container">-->
                <FormItem :label="$t('l.file_des')"
                          :prop="'j_config.'+index+'.explain'"
                          :rules="{required: true, message:  $t('l.remark33'), trigger: 'blur'}">
                  <Input style="width: 300px" class="setting-filed-input" v-model="item.explain"
                         :placeholder="$t('l.remark35')"/>
                </FormItem>
                <!--                              2025年7月17日   王欢  新增 推送程序映射字段-->
                <FormItem label="推送程序映射字段"
                          :prop="'j_config.'+index+'.map_field'">
                  <Input style="width: 300px" class="setting-filed-input" v-model="item.map_field"
                         placeholder="请填写推送程序映射字段"/>
                </FormItem>
                <FormItem style="display: flex;align-items: center" label="是否为电梯推送信息字段"
                          :prop="'j_config.'+index+'.is_elevator_field'">
                  <i-switch v-model="item.is_elevator_field" :true-value="1" size="small" :false-value="0"/>
                </FormItem>
                <div style="display: flex;margin-bottom: 10px;justify-content: end">
                  <div class="filed-button" @click="addPushWay">
                    <span>+</span>
                  </div>
                  <div v-if="index &&　item.map_field !== 'username' &&　item.map_field !== 'password'"　class="filed-button margin-left-10" @click="delPushWay(index)">
                    <span>-</span>
                  </div>
                </div>
                <!--</div>-->
              </Row>
              <!-- 每个 form 中的删除 -->
              <div v-if="item.map_field !== 'username' &&　item.map_field !== 'password'" class="close" @click="delPushWay(index)">
                ×
              </div>
            </Form>
          </Row>
          <Row type="flex" justify="center" style="margin: 20px 0;">
            <Button style="width:100%" @click="addPushWay">{{ $t('l.add_push') }}</Button>
          </Row>
          <FormItem :label="$t('l.m_remarker')">
            <Input v-model="modal.t_push.remark" show-word-limit type="textarea" style="width: 100%"/>
          </FormItem>
          <FormItem :label="$t('l.describe')">
            <Input v-model="modal.t_push.describe" show-word-limit type="textarea" style="width: 100%"/>
          </FormItem>
          <FormItem :label="$t('l.pusher_describe')">
            <Input v-model="modal.t_push.pusher_describe" show-word-limit type="textarea" style="width: 100%"/>
          </FormItem>
        </Form>
      </lg-modal>
    </template>
  </base-page>
</template>

<script>
import lgModal from "../my-components/lg-modal";
import BasePage from "../my-components/base-page";
import util from '@/libs/util';
import paramMap from '../../constant-data/parameter-config';

const roleTypes = {
  ROOT: 1,
  AMDIN: 2,
  PROXY: 3,
  ELEV_FACTORY: 4,
  MT_COMPANY: 5,
  WY_COMPANY: 6,
  GOV: 7,
  AD: 8
}
export default {
  name: 'page-settings',
  components: {BasePage, lgModal},
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error(this.$t('l.remark11')));
      } else if (this.user.id) {
        util.ajax.get(`user/checkuserupdate?mobile=${value}&id=${this.modal.user.id}`).then(res => {
          if (!res.code) {
            callback();
          } else {
            callback(new Error(this.$t('l.remark36')));
          }
        })
      } else callback();
    };
    // 检验用户名
    const validateUsername = (rule, value, callback) => {
      if (this.user.id) { // 注册
        util.ajax.get(`user/checkuserupdatebyusername?username=${value}&id=${this.modal.user.id}`).then(res => {
          if (!res.code) {
            callback();
          } else {
            callback(new Error(this.$t('l.remark37')));
          }
        })
      } else callback();
    }
    //邮箱验证
    const validateEmail = (rule, value, callback) => {
      if ((/^\w+@[a-z0-9]+\.[a-z]+$/i).test(value) || !value) {
        callback();
      } else {
        callback(new Error(this.$t('l.remark14')));
      }
    };
    return {
      settings: {},
      paramMap: paramMap,
      // currentTab: 'monitor',
      faultNotice: {
        loading: false,
        list: {
          j_alarm_config: [],
          j_sms_config: []
        },
        faults: [],
        columns: [
          {
            title: this.$t('l.fault') + ' NO',
            key: 'fault_no',
            width: 100
          },
          {
            title: this.$t('l.fault') + ' CODE',
            key: 'fault_code',
            width: 120
          },
          {
            title: this.$t('l.fault_name'),
            key: 'fault_name',
            width: 300
          },
          {
            title: this.$t('l.fault_mean'),
            key: 'fault_explain'
          },
          {
            title: this.$t('l.fault_alarm'),
            width: 100,
            align: 'center',
            slot: 'alarm'
          },
          {
            title: this.$t('l.send_sms2'),
            width: 100,
            align: 'center',
            slot: 'sms'
          }
        ]
      },
      // 部件使用告警配置
      partsLifeNotice: {
        loading: false,
        data: [],
        list: {
          config: []
        }
      },
      uploadHeadAddress: util.baseURL + 'portal/upload_img',
      uploadAddress: util.baseURL + 'portal/uploadapp',
      uploadPDFAddress: util.baseURL + 'push/upload',
      wcr: {
        // current:'',
        wcrFileList: [], // wcr  展示文件列表
      },
      webrtc: {
        data: {}
      },
      net_trans: "",
      app_version: {
        android: {
          versions: 0,
          url: "",
          size: 0,
          app_name: ''
        }
      },
      face: {
        name: "",
        url: "",
        version: "",
        file_size: ""
      },
      terminal: {
        name: "",
        url: "",
        version: "",
        file_size: ""
      },
      terminallite: {
        name: "",
        url: "",
        version: "",
        file_size: ""
      },
      carousel: { // 轮播图
        value: 0,
        index_banner: []
      },
      user: {
        id: 0,
        username: '',
        job: '',
        mobile: '',
        email: '',
        job_num: '',
        realname: '',
        birthday: ''
      },
      formRules: {
        username: [
          {required: true, message: this.$t('l.remark38'), trigger: 'blur'},
          {validator: validateUsername, trigger: 'blur'}
        ],
        realname: [
          {required: true, message: this.$t('l.remark39'), trigger: 'blur'}
        ],
        // job_num: [
        //     {required: true, message: this.$t('l.remark40'), trigger: 'blur'}
        // ],
        mobile: [
          {required: true, message: this.$t('l.remark41'), trigger: 'blur'},
          {validator: validateMobile, trigger: 'blur'}
        ],
        email: [
          {validator: validateEmail, trigger: 'blur'}
        ]
      },
      settingContent: {
        actived: 0,  // 当前选中项
        list: [],  // card  渲染项
        loading9: false //
      },
      modal: {
        show: false,
        title: this.$t('l.add'),
        t_push: {
          id: 0,
          label: 'pusher_',
          name: '',
          port: 1,
          is_evet_save: "0",
          j_config: [],
          remark: '',
          describe: '',
          j_factory: [],
          docs:'',
          pusher_describe:'',
          disabled:0
        },
        j_region: [], // 所选区域
        // regionTree:[], // 区域树 结构
        factory: { // 选择电梯厂商
          searchLoading: false, // 搜索厂商
          factorys: [],// 厂商
          factory_branchs: [] // 厂商分厂
        },
        list: [] // 所有新增配置列表
      },
      push: {
        push_way: [],
      },
      searchLoading: false,
      allCheak1: false,
      allCheak2: false,
      allCheak3: false,
      closeFaultNotice: true,
      loading: false
    };
  },
  watch: {
    'settingContent.actived': {
      deep: true,
      handler: function (newV, oldV) {
        if (newV == 6) {
          this.loadFaultNoticeConfig();
        }
        if (newV == 10) {
          this.loadPartsLifeConfig();
        }
      }
    }
  },
  computed: {
    isFactory() {
      return this.$store.state.user.user.role === 'ELEV_FACTORY' || 'ROOT';
    },
    current_company() {
      return this.$store.state.user.user.companies.find(item => (item.id == this.$store.state.user.user.current_company)).name;
    },
    cell() {
      return [ // 设置left  单元内容
        {
          name: 0,
          title: this.$t('l.basic_set'),
          label: this.$t('l.personal_account') + '、' + this.$t('l.info_set'),
          selected: false,
          isRoot: 'fun_settings_basesetting'
        },
        {
          name: 1,
          title: this.$t('l.data_monitor_page'),
          label: this.$t('l.data_monitor_set'),
          selected: false,
          isRoot: 'fun_settings_monitor'
        },
        {
          name: 2,
          title: this.$t('l.webRTC_set'),
          label: this.$t('l.webRTC_related_set'),
          selected: false,
          isRoot: 'fun_settings_webrtc'
        },
        {
          name: 3,
          title: this.$t('l.app_v_manage'),
          label: this.$t('l.dtyApp_v_manage'),
          selected: false,
          isRoot: 'fun_settings_app_version'
        },
        {
          name: 4,
          title: this.$t('l.face_v_manage'),
          label: this.$t('l.faceApp_v_manage'),
          selected: false,
          isRoot: 'fun_settings_face_version'
        },
        {
          name: 5,
          title: this.$t('l.smart_v_manage'),
          label: this.$t('l.smartApp_v_manage'),
          selected: false,
          isRoot: 'fun_settings_android_version'
        },
        {
          name: 12,
          title: this.$t('l.smartlite_v_manage'),
          label: this.$t('l.smartlitApp_v_manage'),
          selected: false,
          isRoot: 'fun_settings_parts_life'
        },
        {
          name: 6,
          title: this.$t('l.fault_set'),
          label: this.$t('l.fault_msg_set'),
          selected: false,
          isRoot: 'fun_settings_fault_notice'
        },
        {
          name: 7,
          title: this.$t('l.aliyun_interface_set'),
          label: this.$t('l.aliyun_interface_set'),
          selected: false,
          isRoot: 'fun_settings_aliyun_api'
        },
        // {
        //     name:8,
        //     title:this.$t('l.newWcr_v_manage'),
        //     label:this.$t('l.newWcr_v_manage'),
        //     selected:false,
        //     isRoot:'fun_settings_wcr_version'
        // },
        {
          name: 9,
          title: this.$t('l.api_set1'),
          label: this.$t('l.api_set2'),
          selected: false,
          isRoot: 'fun_settings_filed'
        },
        // 2025年6月19日 删除部件寿命提醒功能
        // {
        //     name: 10,
        //     title: this.$t('l.parts_warn_config'),
        //     label: this.$t('l.parts_warn_config'),
        //     selected: false,
        //     isRoot: 'fun_settings_parts_life'
        // },
        {
          name: 11,
          title: this.$t('l.sys_nettrans_server'),
          label: this.$t('l.sys_nettrans_server'),
          selected: false,
          isRoot: 'fun_settings_parts_life'
        },
      ];
    },
    head_url() {
      if (this.$store.state.user.user && this.$store.state.user.user.head_url) return this.$store.state.user.user.head_url;
      return "https://static.diantiyun.com/upload/image/avatar.png";
    },
    factoryMap() {
      return {};
    },
    columns() {
      return [
        {
          title: this.$t('l.id'),
          key: 'id',
          align: 'center'
        },
        {
          title: this.$t('l.parts_name'),
          key: 'name',
          align: 'center'
        },
        {
          title: this.$t('l.life_limit_default') + "(h)",
          key: 'limit_life',
          align: 'center',
          render: (h, params) => {
            let id = params.row.id;
            return h('Input', {
              props: {
                value: params.row.limit_life,
              },
              on: {
                input: (val) => {
                  let elem = this.partsLifeNotice.list.config.find(elem => elem.id == id);
                  if (elem) {
                    elem.limit_life = val;
                  }
                }
              }
            });
          }
        },
        {
          title: this.$t('l.remark209'),
          slot: 'alarm',
          align: 'center'
        },
      ]
    },
  },
  methods: {
    loadData(force) {
      if (this.isFactory) this.loadFaults();
      if (this.isFactory) this.loadPartsLife();
      new Promise((resolve, reject) => {
        if (!force && this.$store.state.app.lift_state_param_settings) {
          this.settings = this.$store.state.app.lift_state_param_settings;
          resolve(this.settings);
        } else {
          util.ajax.get('/settings/get').then(res => {
            if (!res.code) {
              util.parseJSONResult(res.data, 'webrtc', 'aliyun_config');
              this.$store.commit("update_lift_state_params", res.data);
              resolve(res.data);
            }
          })
        }
      }).then(settings => {

        settings.webrtc = util.parseJSON(settings.webrtc, {});
        Object.keys(settings.webrtc).forEach(appKey => {
          this.webrtc.data[appKey] = settings.webrtc[appKey];
        })

        this.settings = settings
        this.net_trans = settings.net_trans
        this.app_version = util.parseJSON(settings.app_version);
        this.face = util.parseJSON(settings.face, {});
        this.settings.aliyun_config = util.parseJSON(settings.aliyun_config, {});
        this.terminal = util.parseJSON(settings.terminal, {});
        this.terminallite = util.parseJSON(settings.terminallite, {});
        this.wcr.wcrFileList = JSON.parse(settings.wcr_terminal)
        this.carousel.index_banner = this.app_version.index_banner;


      })
      this.clickCell();
    },
    loadFaultNoticeConfig() {
      // this.faultNotice.factory = this.$store.state.user.user.current_company;
      util.ajax.get('/settings/faultnotice').then(res => {
        this.faultNotice.list.j_alarm_config = res.data.j_alarm_config;
        this.faultNotice.list.j_sms_config = res.data.j_sms_config;
        this.allCheak1 = this.faultNotice.faults.length == this.faultNotice.list.j_alarm_config.length
        this.allCheak2 = this.faultNotice.faults.length == this.faultNotice.list.j_sms_config.length
      })
    },
    loadFaults() {
      this.faultNotice.loading = true;
      util.ajax.get('/fault/listtable', {
        params: {
          language: localStorage.getItem("language") ? localStorage.getItem("language") : 'zh'
        }
      }).then(res => {
        this.faultNotice.loading = false;
        this.faultNotice.faults = res.data;
      })
    },
    loadPartsLife() {
      this.partsLifeNotice.loading = true;
      util.ajax.get('/settings/parts').then(res => {
        this.partsLifeNotice.loading = false;
        this.partsLifeNotice.data = res.data;
      })
    },
    loadPartsLifeConfig() {
      util.ajax.get('/settings/parts_config').then(res => {
        let config = this.partsLifeNotice.list.config = res.data.config;    // 电梯厂配置单
        if (config) { // 这个电梯厂存在配置
          let map = {};
          config.forEach(elem => {
            map[elem.id] = elem;
          })
          this.partsLifeNotice.data.forEach(elem => {
            if (map[elem.id]) {
              elem.limit_life = map[elem.id].limit_life;
            }
          })
        }
        this.allCheak3 = this.partsLifeNotice.list.config.length == this.partsLifeNotice.data.length;
      })
    },

    onSave() {
      this.loading = true;

      switch (this.settingContent.actived) {
        case 0:
          this.savePersonalInformation();
          break;
        case 1:
          this.saveMonitorConfig();
          break;
        case 6:
          this.saveFaultNoticeConfig();
          break;
        case 2:
          this.saveWebrtcConfig();
          break;
        case 4:
          this.saveFaceConfig();
          break;
        case 3:
          this.saveAppConfig();
          break;
        case 5:
          this.saveTerminalConfig();
          break;
        case 7:
          this.saveAliyunConfig();
          break;
          // case 8:
          //     this.saveNewWcrConfig();
          //     break;
        case 10:
          this.savePartsLifeNoticeConfig();
          break;
        case 11:
          this.saveNetTransConfig();
          break;
        case 12:
          this.saveTerminalLiteConfig();
          break;
      }
    },
    savePersonalInformation() {
      if (this.user.birthday) this.user.birthday = new Date(this.user.birthday).pattern("yyyy-MM-dd")
      util.ajax.put("/settings/user", this.user).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.edit_success'))
      }).then(() => {
        // 编辑的是自己 并 自己添加了新的部门或者公司 删除自己的缓存重新封装$store
        util.getAuth();
      })
    },
    saveNetTransConfig() {
      util.ajax.put('/settings/savenettrans', {data: this.net_trans}).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
        this.$store.commit("update_lift_state_params", this.settings)
      })
    },
    saveWebrtcConfig() {
      util.ajax.put('/settings/savertc', this.webrtc.data).then(res => {
        this.loading = false;
        this.$Message.success(this.$t('l.save_success'))
        this.settings.webrtc = this.webrtc.data;
        this.webrtc.data = {};
        this.$store.commit("update_lift_state_params", this.settings)
      })
    },
    saveAppConfig() {
      util.ajax.put('/settings/saveapp', this.app_version).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },
    saveAliyunConfig() {
      util.ajax.put('/settings/savealiyun', this.settings.aliyun_config).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },
    // 保存新版wcr配置
    // saveNewWcrConfig(){
    //     this.loading = false;
    // },
    saveTerminalConfig() {
      util.ajax.put('/settings/saveterminal', this.terminal).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },
    saveTerminalLiteConfig() {
      util.ajax.put('/settings/saveterminallite', this.terminallite).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },
    saveFaceConfig() {
      util.ajax.put('/settings/saveface', this.face).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },
    saveMonitorConfig() {
      util.ajax.put('/settings/savemonitor', this.settings.j_monitor_config).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
        this.$store.commit("update_lift_state_params", this.settings)
      })
    },
    onFaultAlarmConfigChange(evt, faultNo) {
      if (evt && !this.faultNotice.list.j_alarm_config.includes(faultNo)) this.faultNotice.list.j_alarm_config.push(faultNo);
      else if (!evt && this.faultNotice.list.j_alarm_config.includes(faultNo)) this.faultNotice.list.j_alarm_config.splice(this.faultNotice.list.j_alarm_config.indexOf(faultNo), 1);
      this.allCheak1 = this.faultNotice.list.j_alarm_config.length == this.faultNotice.faults.length;
    },
    onFaultSmsConfigChange(evt, faultNo) {
      if (evt && !this.faultNotice.list.j_sms_config.includes(faultNo)) this.faultNotice.list.j_sms_config.push(faultNo);
      else if (!evt && this.faultNotice.list.j_sms_config.includes(faultNo)) this.faultNotice.list.j_sms_config.splice(this.faultNotice.list.j_sms_config.indexOf(faultNo), 1);
      this.allCheak2 = this.faultNotice.list.j_sms_config.length == this.faultNotice.faults.length;
    },
    saveFaultNoticeConfig() {
      util.ajax.put('/settings/savefaultnotice', this.faultNotice.list).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },

    onPartsLifeNoticeChange(evt, row) {
      if (evt && !this.partsLifeNotice.list.config.find(elem => elem.id == row.id)) this.partsLifeNotice.list.config.push({
        id: row.id,
        name: row.name,
        limit_life: row.limit_life
      });
      else if (!evt && this.partsLifeNotice.list.config.find(elem => elem.id == row.id)) this.partsLifeNotice.list.config.splice(this.partsLifeNotice.list.config.findIndex(elem => elem.id == row.id), 1);
      this.allCheak3 = this.partsLifeNotice.list.config.length == this.partsLifeNotice.data.length;
    },

    savePartsLifeNoticeConfig() {
      util.ajax.post('/settings/savepartslife', {
        factory_cid: this.$store.state.user.user.current_company,
        config: this.partsLifeNotice.list.config,
      }).then(res => {
        this.loading = false;
        if (!res.code) this.$Message.success(this.$t('l.save_success'))
      })
    },
    changeCheck(v, i) {
      if (i == 1) { // 短信全选、非全选
        this.faultNotice.list.j_alarm_config = [];
        if (v) {
          this.faultNotice.faults.forEach(elem => {
            this.faultNotice.list.j_alarm_config.push(elem.fault_no)
          })
        }
      } else { // 告警提示
        this.faultNotice.list.j_sms_config = [];
        if (v) {
          this.faultNotice.faults.forEach(elem => {
            this.faultNotice.list.j_sms_config.push(elem.fault_no)
          })
        }
      }
    },
    rowClassName(row, index) {
      if (this.faultNotice.list.j_alarm_config && this.faultNotice.list.j_alarm_config.includes(row.fault_no)) return 'row-fault-sms-active';
      if (this.faultNotice.list.j_sms_config && this.faultNotice.list.j_sms_config.includes(row.fault_no)) return 'row-fault-sms-active';
      return '';
    },
    rowPartsClassName(row, index) {
      if (this.partsLifeNotice.config && this.partsLifeNotice.list.config.includes(row.id)) return 'row-parts-life-active';
      if (this.partsLifeNotice.config && this.partsLifeNotice.list.config.includes(row.id)) return 'row-parts-life-active';
      return '';
    },

    uploadSuccess(res, file) {
      if (!res.code) {
        this.carousel.index_banner[res.data.index].url = res.data.url + '?m=' + Math.random();
        this.$Message.success(this.$t('l.upload_success'))
      } else {
        this.$Message.success(this.$t('l.upload_fail'))
      }
    },
    uploadHeadSuccess(res, file) {
      if (!res.code) {
        this.$Message.success(this.$t('l.upload_success'))
        // 提交store 改变head_url
        this.$store.commit("updateHeadUrl", res.data.head_url);
        return;
      }
      this.$Message.error(this.$t('l.upload_fail'));
    },
    handleBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (this.wcr.wcrFileList.length) {
          let f = this.wcr.wcrFileList.find((elem => {
            return elem == file.name;
          }));
          if (f) {
            this.$Modal.confirm({
              title: this.$t('l.warning'),
              content: this.$t('l.remark25'),
              okText: this.$t('l.continue'),
              onOk: () => {
                resolve();
              },
              oncancel: () => {
                reject();
              }
            })
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });

    },
    handleSuccess(res, file, fileList) {
      if (!res.code) {    //    上传成功之后 修改input
        switch (res.data.index) {
          case 0: // 手机app
            this.app_version.android.size = file.size;
            this.app_version.android.versions = res.data.version;
            break;
          case 1: // 安卓人脸识别终端
            this.face.file_size = file.size;
            this.face.name = file.name;
            this.face.url = "https://static.diantiyun.com/upload/apk/" + file.name;
            break;
          case 2: // 安卓一体机apk
            this.terminal.file_size = file.size;
            this.terminal.name = file.name;
            this.terminal.url = "https://static.diantiyun.com/upload/apk/" + file.name;
            break;
          case 3: // 新版wcr
            this.wcr.wcrFileList = res.data.wcr_version_list
            break;
          case 4: // 智慧屏Lite
            this.terminallite.file_size = file.size;
            this.terminallite.name = file.name;
            this.terminallite.url = "https://static.diantiyun.com/upload/apk/" + file.name;
            break;
        }
        this.$Message.success(this.$t('l.upload_success'))
      } else {
        this.$Message.error(this.$t('l.upload_fail'))
      }
    },

    handleDocUploadSuccess(res, file, fileList) {
      this.modal.t_push.docs = "";
      if (!res.code) {    //    上传成功之后 修改input
        // let fileUploadSucList = fileList.filter(f =>f.response.code === 0).map(f =>f.response.data);
        this.modal.t_push.docs = this.modal.t_push.docs ? this.modal.t_push.docs +","+res.data : res.data;
        console.log( this.modal.t_push.docs );
        this.$Message.success(this.$t('l.upload_success'))
      } else {
        this.$Message.error(this.$t('l.upload_fail'))
      }
    },

    removeDocUpload(file, fileList){
      console.log(file,fileList);
    },

    handleDocUploadError() {
      this.$Message.error("上传失败，请上传pdf文件")
      return;
    },
    handleFormatError(error, file, fileList) {
      this.$Message.error(this.$t('l.remark26'))
      return;
    },
    clickCell(name = 0) {
      this.settingContent.actived = name;
      this.cell.forEach(elem => {
        if (elem.name == name) {
          elem["selected"] = true;
        } else {
          elem["selected"] = false;
        }
      })

    },
    preAddNewTaocan() {
      this.settings.aliyun_config.simPackages.push({
        offerid: '',
        name: '',
        originPrice: 0,
        price: 0,
        type: 'A',
        flow: ''
      })
    },
    // 加载 已配置过的推送方式
    loadReginAccessPermitData() {
      this.settingContent.loading9 = true;
      util.ajax.get('/push/accesspermit').then(res => {
        this.settingContent.loading9 = false;
        if (res.data && res.data.length) {
          this.modal.list = res.data.map(elem => {
            util.parseJSONResult(elem);
            return elem;
          })
        }
      })
    },
    add_settings() {
      this.push.push_way = [];
      this.modal.t_push = {
        id: 0,
        label: 'pusher_',
        name: '',
        port: 1,
        is_evet_save: "0",
        disabled:0,
        j_config: [
          {
            id:this.generateShortId(),
            filed: 'username',
            explain: '账号',
            map_field: 'username',
            is_elevator_field: 0
          },
          {
            id:this.generateShortId(),
            filed: 'password',
            explain: '密码',
            map_field: 'password',
            is_elevator_field: 0
          },
        ],
        remark: '',
        j_factory: [],
        docs:'',
        pusher_describe:''
      };
      this.modal.show = true;
    },

    // 同步redis
    synchro_redis(type) {
      util.ajax.get("/device/synchroRedis", {
        params: {
          type
        }
      }).then(res => {
        if (res.code == 0) {
          let style = {
            fontSize: "14px",
            fontWeight: '500',
            padding: '5px 0'
          };
          this.$Notice.open({
            title: '消息推送中...',
            duration: 10,
            render: h => {
              return h('div', [
                h('p', {style}, `当前配置推送设备总数：${res.data.total}`),
                h('p', {style}, `当前redis中存在总数：${res.data.redis_total}`),
              ])
            }
          });
        }

      });


    },


    // 更新电梯表中的方案
    updateShemeCodeToDevice(){
      util.ajax.get("/push/updateScheme").then(res => {
        if(!res.code){
          this.$Message.success(this.$t("l.success"));
        }
      });
    },

    // 添加新的推送的配置
    addPushWay() {
      this.modal.t_push.j_config.push({
        id:this.generateShortId(),
        filed: '',
        explain: '',
        map_field: '',
        is_elevator_field: 1
      })
    },

    generateShortId() {
      const uuid = crypto.randomUUID();
      const hex = uuid.replace(/-/g, ''); // 移除横杠
      const base62Chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      let shortId = '';
      // 将 16 进制转为 Base62
      let number = BigInt('0x' + hex);
      while (number > 0) {
        const remainder = Number(number % 62n);
        shortId = base62Chars[remainder] + shortId;
        number = number / 62n;
      }
      return shortId.padStart(22, '0'); // 补零至固定长度
    },

    // 删除推送方式的
    delPushWay(index) {
      let item = this.modal.t_push.j_config[index];
      if(item.map_field === "username" || item.map_field === "password"){
        this.$Message.error("用户名密码字段禁止删除");
        return
      }
      this.modal.t_push.j_config.splice(index, 1);
    },
    //编辑配置信息
    preEdit(index) {
      this.modal.t_push = this.modal.list[index];
      this.modal.title = this.$t('l.edit')
      this.modal.show = true;
    },
    // 提交新增配置
    onSubmit(name1, name2) {
      this.$refs[name1].validate((valid) => {
        if (valid) {
          // 验证新增的推送配置
          // if (this.$refs[name2]) {
          //     this.$refs[name2][0].validate((valid1) => {
          // console.log(this.modal.t_push,valid1)
          // if (valid1) { // 推送方式保存
          if (this.modal.t_push.id) { // 修改
            this.$Modal.confirm({
              title: "警告",
              content: "确定修改当前配置吗？",
              okText: this.$t('l.confirm'),
              cancelText: this.$t('l.cancel'),
              onOk: () => {
                util.ajax.post("push/update", this.modal.t_push).then(res => {
                  if (!res.code) {
                    this.modal.show = false
                    this.$Message.success(this.$t('l.success'));
                    this.loadReginAccessPermitData();
                  }
                })
              }
            })
          } else {
            util.ajax.post("push/add", this.modal.t_push).then(res => {
              if (!res.code) {
                this.modal.show = false
                this.$Message.success(this.$t('l.success'));
                this.loadReginAccessPermitData();
              }
            })
          }
        } else {
          this.$Message.warning(this.$t('l.remark24'));
        }
      })
    },
    remoteSearchFactory(value) {
      if (!value.trim()) return;
      this.searchLoading = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value + '%',
        }
      }).then(res => {
        this.searchLoading = false;
        res.data.map(company => {
          if (roleTypes.ELEV_FACTORY == company.role_id && !this.factoryMap[company.id]) {
            this.modal.factory.factorys.push(company);
            this.factoryMap[company.id] = company;
          }
        })
      })
    },
    loadOptions() {
      util.ajax.get('/device/getParentFactory').then(res => {
        if (res.data) {
          this.modal.factory.factorys = [];
          res.data.company.forEach(company => {
            this.modal.factory.factorys.push(company);
            this.factoryMap[company.id] = company;
          })
        }
      })
    },
    closeFnotice(v) {
      this.closeFaultNotice = v;
      localStorage.setItem("close_fault_notice", v ? v : '');
    },
    //     选择所有可见厂商
    selectFactory(value) {
      if (value.indexOf("*") != -1) {  // 代表全部，需要特殊处理
        this.modal.t_push.j_factory = ["*"];
      }
    },
    onChangeAllPartsLife(e) {
      if (e) {
        this.partsLifeNotice.list.config = this.partsLifeNotice.data;
      } else {
        this.partsLifeNotice.list.config = [];
      }
    }
  },
  created() {
    this.loadOptions();
    this.loadData();
    this.loadReginAccessPermitData();
    localStorage.getItem('close_fault_notice') ? this.closeFaultNotice = true : this.closeFaultNotice = false;
  },
  mounted() {

    this.clickCell();
    Object.keys(this.user).forEach(key => {
      if (key == 'birthday') {
        this.user[key] = this.$store.state.user.user[key]
      }
      this.user[key] = this.$store.state.user.user[key]
    })
  },
};

</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  display: none;
}

.check-box-line {
  display: block;
}

//透明效果
.opacity {
  opacity: 0.6;
  width: 102px;
}

.opacity:hover {
  opacity: 1;
}

.setting-content {
  h3 {
    line-height: 40px;
  }

  .checkBox {
    max-height: 50vh;
    overflow-y: auto;
  }
}

/*.head-portrait{*/

/**/
/*border-radius: 50%;*/
/*margin-bottom: 20px;*/
/*background-repeat: no-repeat;*/
/*background-size: cover;*/
/*}*/
.face-data-img-box {
  width: 150px;
  height: 150px;
  overflow: hidden;
  margin-right: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  border: 4px solid #0984e3;
  display: flex;
  justify-content: center;
  align-content: center;
  background-repeat: round;
}

.face-data-img-box img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.head-portrait-button {
  width: 150px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.jian {
  padding: 0 2px;
}

.filed-button {
  border: 1px solid #dcdee2;
  padding: 5px;
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filed-button:hover {
  cursor: pointer;
  border: 1px solid #33ccff;

}

.filed-explain-container {
  display: flex;
  align-items: flex-end;
  margin-left: 10px;
  /*margin-bottom: 24px;*/
}

.push-way-form {
  border: 1px solid #dcdee2;
  padding: 20px 20px 0px 20px;
  margin-bottom: 20px;
  position: relative;
}

.close {
  width: 20px;
  height: 20px;
  border: 1px solid #dcdee2;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.pre-edit {
  color: #39f !important;
}
</style>
